import util from "@/utils/index";
const mutations = {
    // 用于action成功后设置数据,数据不会被处理
    set(state, params) {
        state[params.name] = params.data;
    },
    // 车主银行卡列表
    bankList(state, params) {
        const data = params.data;
        // 遍历树形数据，重组数据
        util.eachList(data, function(item) {
            item.bankNo = util.sliceLast(item.bankCardNumber)
        });
        state.bankList = data;
    }
}
export default mutations